module.exports = __webpack_public_path__ + "static/blob-bottom-galini-6d04a72aa3aee4d389415b34796c9c53.png";